// extracted by mini-css-extract-plugin
export var container = "Banner-module--container--BV1X9";
export var ctas = "#226355";
export var description = "Banner-module--description--Lj0SE";
export var descriptionContainer = "Banner-module--descriptionContainer--ggVNV";
export var grayBackground = "#f6f8fb";
export var image = "Banner-module--image--Ryayt";
export var rowContent = "Banner-module--rowContent--AS+lY";
export var storeImg = "Banner-module--storeImg--nrYZQ";
export var storeLink = "Banner-module--storeLink--e96KL";
export var storesIcons = "Banner-module--storesIcons--ZpIPe";